<div class="message-container">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header d-flex text-break align-items-center">
                    <button *ngIf="isMobileDevice" (click)="unselectConversation()" class="btn btn-primary me-2" type="button">
                        <fa-icon class="button-icon-center" [icon]="faChevronLeft"></fa-icon>
                    </button>
                    <h5>{{ messageData && messageData.length != 0 ? messageData[0].chatName: 'No Active conversation' }}</h5>
                    <div class="ms-auto d-flex align-items-center">
                        <button (click)="openInCallDialog()" class="btn btn-primary" type="button">
                            <fa-icon class="button-icon-center" [icon]="faPhone"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="card-body scrollable" #scrollMe (scroll)="onScroll($event)">
                    <div class="messages">
                        <div class="row">
                            <div *ngFor="let message of messageData" class="col-sm-12 text-center">
                                <span class="message-date">{{message.date}}</span>
                                <div *ngFor="let convo of message.conversations" class="row">
                                    <div *ngIf="convo.senderNumber != currentUserNumber" class="col-sm-6 text-start">
                                        <div *ngIf="convo.type === 'message'" class="message-box-received">
                                            <span>{{convo.message}}</span>
                                        </div>
                                        <div *ngIf="convo.type === 'email'">
                                            <fa-icon class="button-icon-center color-green"
                                                [icon]="faEnvelope"></fa-icon><span>
                                                {{convo.message}}
                                            </span>
                                        </div>
                                        <div class="text-start py-1 px-1">
                                            <span class="message-time"> {{convo.time}}</span>
                                        </div>
                                        <div *ngIf="convo.type.includes('video')" class="message-box-received">
                                            <video width="320" height="240" controls>
                                                <source [src]="convo.media.url" [type]="convo.type">
                                              Your browser does not support the video tag.
                                            </video>
                                        </div>
                                        <div *ngIf="convo.type === 'misscall'" class="message-box-received">
                                            <span><fa-icon style="color:red;" class="button-icon-center" [icon]="faPhone"></fa-icon>
                                            You missed a call, click <a href="_" (click)="openInCallDialog()">here</a> to call back.</span>
                                        </div>
                                        <div *ngIf="convo.type === 'call'" class="message-box-received">
                                            <span><fa-icon class="button-icon-center" [icon]="faPhone"></fa-icon> Call duration: 1:54 mins</span>
                                        </div>
                                        <div *ngIf="convo.type.includes('image')" class="message-box-received my-2">
                                            <img style="max-height: 330px; max-width: 360px;" [src]="convo.media.url">
                                        </div>
                                        <div *ngIf="convo.type.includes('audio')" class="message-box-received">
                                            <audio *ngIf="convo.type === 'audio/mpeg' || convo.type === 'audio/ogg' || convo.type === 'audio/wav'" width="320" height="240" controls>
                                                <source [src]="convo.media.url" [type]="convo.type">
                                            </audio>
                                            <div *ngIf="convo.type != 'audio/mpeg' || convo.type != 'audio/ogg' || convo.type != 'audio/wav'">
                                                Audio Message received. Click <a [href]="convo.media.url" download>here</a> to download.
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="convo.senderNumber != currentUserNumber" class="col-sm-6">
                                    </div>
                                    <div *ngIf="convo.senderNumber == currentUserNumber" class="col-sm-6"></div>
                                    <div *ngIf="convo.senderNumber == currentUserNumber" class="col-sm-6 text-end">
                                        <div *ngIf="convo.type === 'call'">
                                            <fa-icon class="button-icon-center color-green"
                                                [icon]="faPhone"></fa-icon><span> {{convo.message}}</span>
                                        </div>
                                        <div *ngIf="convo.type === 'email'">
                                            <fa-icon class="button-icon-center color-green"
                                                [icon]="faEnvelope"></fa-icon> <span>
                                                You have sent an email to Gaston. Click <a class="email-link"
                                                    (click)="openEmailViewModal(convo.data)">here</a> to view it's
                                                content.
                                            </span>
                                        </div>
                                        <div *ngIf="convo.type === 'message'" class="message-box-sender">
                                            <span>{{convo.message}}</span>
                                        </div>
                                        <div *ngIf="convo.type === 'misscall'" class="message-box-sender">
                                            <span><fa-icon style="color:red;" class="button-icon-center" [icon]="faPhone"></fa-icon>
                                            You missed a call, click <a href="_" (click)="openInCallDialog()">here</a> to call back.</span>
                                        </div>
                                        <div *ngIf="convo.type === 'call'" class="message-box-sender">
                                            <span><fa-icon class="button-icon-center" [icon]="faPhone"></fa-icon> Call duration: 1:54 mins</span>
                                        </div>
                                        <div *ngIf="convo.type.includes('video')" class="message-box-sender">
                                            <video width="320" height="240" controls>
                                                <source [src]="convo.media.url" [type]="convo.type">
                                              Your browser does not support the video tag.
                                            </video>
                                        </div>
                                        <div *ngIf="convo.type.includes('audio')" class="message-box-sender">
                                            <audio *ngIf="convo.type === 'audio/mpeg' || convo.type === 'audio/ogg' || convo.type === 'audio/wav'" width="320" height="240" controls>
                                                <source [src]="convo.media.url" [type]="convo.type">
                                            </audio>
                                            <div *ngIf="convo.type != 'audio/mpeg' || convo.type != 'audio/ogg' || convo.type != 'audio/wav'">
                                                Audio Message received. Click <a [href]="convo.media.url" download>here</a> to download.
                                            </div>
                                        </div>
                                        <div *ngIf="convo.type.includes('image')" class="message-box-sender">
                                            <img style="max-height: 330px; max-width: 360px;" [src]="convo.media.url">
                                        </div>
                                        <div class="text-end py-1 px-1">
                                            <span class="message-time"> {{convo.time}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-muted message-content-footer">
                    <div class="row">
                        <form [formGroup]="messagingForm" (ngSubmit)="sendSMS()">
                            <div *ngIf="fileObject.file" class="col-sm-12 preview-img-div no-pd-right">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <img class="img-max" [src]="fileObject.file">
                                    </div>
                                    <div class="col-sm-4 text-center align-self-center">
                                        {{fileObject.filename}}
                                    </div>
                                    <div  class="col-sm-4 text-end align-self-center">
                                        <button (click)="removeFile()" class="btn btn-danger">
                                            <fa-icon class="button-icon-left" [icon]="faTrash"></fa-icon>
                                            <span>Delete</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 no-pd-right">
                                <input accept="image/png, image/gif, image/jpeg" type="file" hidden #file (change)="selectMedia($event)">
                                <textarea rows="4" cols="50" class="form-control text-area"
                                    formControlName="message"></textarea>
                            </div>
                            <div class="col-sm-12 text-end mt-2 no-pd-right">
                                <button type="button" class="btn btn-primary" (click)="file.click()">
                                    <fa-icon class="button-icon-left" [icon]="faFileUpload"></fa-icon>
                                    <span>Attach File</span>
                                </button>
                                <button class="btn btn-primary ms-2" type="submit" [disabled]="!(messagingForm.valid || uploadedFile)">
                                    <fa-icon class="button-icon-left" [icon]="faPaperPlane"></fa-icon>
                                    <span>Send</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
